export var SpecifiedDateType;
(function (SpecifiedDateType) {
    SpecifiedDateType[SpecifiedDateType["Yesterday"] = 0] = "Yesterday";
    SpecifiedDateType[SpecifiedDateType["Today"] = 1] = "Today";
    SpecifiedDateType[SpecifiedDateType["Tomorrow"] = 2] = "Tomorrow";
    SpecifiedDateType[SpecifiedDateType["LastWeek"] = 3] = "LastWeek";
    SpecifiedDateType[SpecifiedDateType["ThisWeek"] = 4] = "ThisWeek";
    SpecifiedDateType[SpecifiedDateType["NextWeek"] = 5] = "NextWeek";
    SpecifiedDateType[SpecifiedDateType["LastMonth"] = 6] = "LastMonth";
    SpecifiedDateType[SpecifiedDateType["ThisMonth"] = 7] = "ThisMonth";
    SpecifiedDateType[SpecifiedDateType["NextMonth"] = 8] = "NextMonth";
    SpecifiedDateType[SpecifiedDateType["LastYear"] = 9] = "LastYear";
    SpecifiedDateType[SpecifiedDateType["ThisYear"] = 10] = "ThisYear";
    SpecifiedDateType[SpecifiedDateType["NextYear"] = 11] = "NextYear";
    SpecifiedDateType[SpecifiedDateType["Range"] = 12] = "Range";
})(SpecifiedDateType || (SpecifiedDateType = {}));
;
